import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { SlotBookingContainer } = await import('@containers/Scheduling/SlotBooking');
    return {
        Component: SlotBookingContainer,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
